import type { Blocker } from 'react-router'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { listSentence } from '@/lib/formatters'

interface UnsavedEditsDialogProps {
  blocker: Blocker
  labels: string[]
}

export function UnsavedEditsDialog({ blocker, labels }: UnsavedEditsDialogProps) {
  const blocked = blocker.state === 'blocked'

  function stay() {
    if (blocker.state === 'blocked') blocker.reset()
  }

  function leave() {
    if (blocker.state === 'blocked') blocker.proceed()
  }

  return (
    <Dialog open={blocked} onOpenChange={(open) => !open && stay()}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>Leave without saving?</DialogTitle>
          <DialogDescription>Your edits to {listSentence(labels)} aren&apos;t saved.</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={stay}>
            Stay
          </Button>
          <Button type="button" variant="destructive" onClick={leave}>
            Leave anyway
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
